import { Fragment, memo } from 'react';
import CivilStatus from '../../shared/civil-status';
import EditData from '../../shared/edit-data';
import CivilUnion from './civil-union';
import AccordionPerson from 'shell/components/shared/person';

interface RegistrationCivilUnionNonResidentProps {
  editSipoUrl?: string;
}

const RegistrationCivilUnionNonResidentComponent = ({
  editSipoUrl,
}: RegistrationCivilUnionNonResidentProps): React.ReactElement => {
  return (
    <Fragment>
      <AccordionPerson disabled />
      <EditData />
      <CivilStatus disabled />
      <CivilUnion editSipoUrl={editSipoUrl} />
    </Fragment>
  );
};

RegistrationCivilUnionNonResidentComponent.displayName =
  'Registration CivilUnion Non resident component';

const RegistrationCivilUnionNonResident = memo(RegistrationCivilUnionNonResidentComponent);

export default RegistrationCivilUnionNonResident;
